import useProjectStore from '../components/ProjectCanvas/useProjectStore';
import { filterPropertiesBeforeSave } from './noteUtils';
//this is a constructor for a save event
export function createSaveEvent(type, projectId, viewport, elements, eventData) {
  let saveEvent = {
    projectId: projectId,
    type: type,
    viewport: viewport,
    positions: useProjectStore.getState().readCanvasIntoComponents(elements),
    notePositions: filterPropertiesBeforeSave(useProjectStore.getState().readCanvasIntoNotes(elements)),
    eventData: eventData,
  };

  return saveEvent;
}
